export function report(eventName: string, params?: any) {
    let win: any = window;
    if (win && win.gtag) {
        win.gtag("event", eventName, params);
    }
}
